export { default } from './BrandCardLink.js'
